export enum LearningOutcomesStatusEnum {
  GET_LEARNING_OUTCOMES = 'profile/learning-outcomes',
}


export interface IResultCoursesItem {
  // Программа
  event_name: string;
  // Компетенции
  competences: Array<string>;
  // Профессия
  profession_name: string;
  // Направление ОПП
  direction_prog_name: string;
  // Вид программы
  type_name: string;
  // Подвид программы
  sub_type_name: string;
  // Группа
  group_name: string;
  // Обучающая организации
  event_edu_partners: Array<string>;
  // Расписание
  schedule_dates: Array<string>;
  // Итоговая оценка
  mark_final: string;
}

export type IResultCoursesItems = Array<IResultCoursesItem>;

export interface LearningOutcomeItem {
  id: string;
  event_name: string; // программа
  competences: string; // компетенции
  profession_name: string; // Профессия
  direction_prog_name: string; // Направление ОПП
  type: string; // Вид программы
  sub_type: string; // Подвид программы
  group_name: string; // Группа
  event_edu_partners: string; // Обучающая организация
  mark_final: string | null; // Итоговая оценка
  date_from: string;
  date_to: string;
  document_flows: null;
  // TODO: как появится document_id - поправить ожидаемый тип данных и обязательность параметра
  document_id: number | null;
  // TODO: как появятся url_code и program_id (названия могут измениться) - поправить ожидаемый тип данных и обязательность параметра
  url_code: string;
  program_id: string;
  registry_training_document_id: string;
}

type QueryParamKeys =
  | string
  | number
  | boolean
  | Array<string>
  | Array<number>
  | Array<boolean>;

export interface QueryParams {
  [key: string]: QueryParamKeys;
}

export interface ResponseBody<T> {
  data: T;
  err_code: number;
  filtered: number;
  limit: string;
  page: number;
  success: boolean;
  token: string;
}

export interface errorHandler {
  (status: number): Error;
}

export interface ErrorHandler<T> {
  (response: ResponseBody<T>, handler: errorHandler): T;
}



// WEBPACK FOOTER //
// ./src/pages/profile/views/resultCourses/types.ts